import React from 'react';
import { useLocation } from 'react-router-dom';
import { useSandboxSession } from '../sandbox/SandboxSessionContext';
import { DEVICES, VIEW_AS_FRAME_NAME } from './ViewAsContext';

/**
 * Tablet and phone sizes load the same shell in a frame of that width, so the
 * layout responds to the device's width rather than to the desktop window.
 */
export default function ViewAsDeviceStage({ banner, device, target }) {
  const location = useLocation();
  const { isPreviewActive, sandboxContext } = useSandboxSession();
  const size = DEVICES[device];
  // The frame opens the same draft the banner shows; its own shell reads it from the URL.
  const params = new URLSearchParams(location.search);
  if (isPreviewActive && sandboxContext?.sandbox_id) {
    params.set('sandbox', sandboxContext.sandbox_id);
    if (sandboxContext.active_overlay_id) params.set('overlay', sandboxContext.active_overlay_id);
  }
  const query = params.toString();
  const src = `${location.pathname}${query ? `?${query}` : ''}`;
  return (
    <div className="flex h-screen flex-col bg-slate-200" data-testid="view-as-device-stage">
      {banner}
      <div className="flex min-h-0 flex-1 items-start justify-center overflow-auto p-6">
        {/* A new viewer or draft reloads the frame even when the page stays the same. */}
        <iframe
          key={`${target}:${isPreviewActive ? sandboxContext?.sandbox_id : 'live'}`}
          name={VIEW_AS_FRAME_NAME}
          title={`${device} screen`}
          src={src}
          style={{ width: `${size.width}px`, height: `${size.height}px` }}
          className="box-content shrink-0 rounded-[28px] border-[10px] border-slate-900 bg-white shadow-xl"
          data-testid="view-as-device-frame"
        />
      </div>
    </div>
  );
}
